import { DownloadSecurityContainerController } from '../controller/DownloadSecurityContainerController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class DownloadSecurityContainerWebComponent extends BaseWebComponentElement {
  private packageId: string;
  private useNewDataRepository = false;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DownloadSecurityContainerController,
    });
  }

  public setPackageId(packageType: string): void {
    this.packageId = packageType;
  }

  public getPackageId(): string {
    return this.packageId;
  }

  public setUseNewDataRepository(useNewDataRepository: boolean): void {
    this.useNewDataRepository = useNewDataRepository;
  }

  public getUseNewDataRepository(): boolean {
    return this.useNewDataRepository;
  }
}
